import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon_code",
  "use": "icon-icon_code-usage",
  "viewBox": "0 0 24 18",
  "content": "<symbol viewBox=\"0 0 24 18\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-icon_code\">\n    <path d=\"M12 0L10 18H12L14 0H12ZM5.70703 3.29297L0 9L5.70703 14.707L7.12109 13.293L2.82812 9L7.12109 4.70703L5.70703 3.29297ZM18.293 3.29297L16.8789 4.70703L21.1719 9L16.8789 13.293L18.293 14.707L24 9L18.293 3.29297Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol